import React from 'react';
import Pagination from '../Pagination';
import SearchResult from '../posts/SearchResult';
// import LinkArrow from '../LinkArrow';
import SearchTopInput from '../SearchTopInput';

function LayoutSearch(props) {
    const {
        results,
        currentSearchTerm,

        posts,
        // acfData,
        postsPerRow,
        currentPage,
        maxPages,
        loading,
        paginationStyle,

        pageNext,
        pagePrev,
        setCurrentPage,

        searchFieldChange,
        scrollUp,
    } = props;

    const loadingClass = loading ? 'loading-active' : '';

    const postItems = posts.map((post, index) => {
        if (posts) {
            return (
                <SearchResult
                    post={post}
                    key={index}
                    currentSearchTerm={currentSearchTerm}
                />
            );
        }
    });

    let postsContent;
    let paginationContent;

    if (paginationStyle === 'more') {
        paginationContent = (
            <LoadMore
                currentPage={currentPage}
                maxPages={maxPages}
                pageNext={pageNext}
                pagePrev={pagePrev}
                setCurrentPage={setCurrentPage}
                scrollUp={scrollUp}
            ></LoadMore>
        );
    } else if (paginationStyle === 'pagination') {
        paginationContent = (
            <Pagination
                currentPage={currentPage}
                maxPages={maxPages}
                pageNext={pageNext}
                pagePrev={pagePrev}
                setCurrentPage={setCurrentPage}
                scrollUp={scrollUp}
            ></Pagination>
        );
    }

    if (posts && posts.length > 0) {
        postsContent = (
            <div>
                <div
                    className={`eight29-posts ${loadingClass}`}
                    style={postsPerRow}
                >
                    {postItems}
                </div>

                {paginationContent}
            </div>
        );
    } else {
        if (!loading) {
            postsContent = (
                <div className="no-results">
                    <p className="leadparagraph">
                        We can’t seem to find any results for that.
                    </p>
                    {/* {acfData.search_links &&
                        acfData.search_links.map((item, index) => {
                            return <LinkArrow link={item.link} key={index} />;
                        })} */}
                </div>
            );
        }
    }

    return (
        <div className="app-layout layout-search">
            <div className="container">
                <div className="row justify-content-lg-center">
                    <div className="col-12 col-lg-8">
                        <SearchTopInput
                            currentSearchTerm={currentSearchTerm}
                            searchFieldChange={searchFieldChange}
                            results={results}
                        ></SearchTopInput>
                    </div>
                </div>
            </div>
            <section className="eight29-posts-container">
                <div className="container">
                    <div className="row justify-content-lg-center">
                        <div className="col-12 col-lg-8">{postsContent}</div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LayoutSearch;
